import Vue from 'vue';
import App from './App.vue';
import router from './router';
import i18n from './locales';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import VideoPlayer from 'vue-video-player';
Vue.use(VueAwesomeSwiper);
Vue.use(VideoPlayer);
import vueHeadful from 'vue-headful';
Vue.component('vue-headful', vueHeadful);
Vue.config.productionTip = false;
window.router = router;
new Vue({
  i18n,
  router,
  render: h => h(App),
}).$mount('#app');
